// header-groupの"一番最初"の要素の高さを計算する関数
function getFirstHeaderSectionHeight() {
    const firstHeaderSection = document.querySelector('.shopify-section-group-header-group');
    if (firstHeaderSection) {
        return firstHeaderSection.offsetHeight;
    } else {
        return 0;
    }
}

// 各要素の取得
const headerWrapper = document.getElementById('HeaderWrapper');
const siteHeader = document.getElementById('SiteHeader');
const mainContent = document.getElementById('MainContent'); // MainContent要素を追加

// 計算したヘッダーの高さを格納する変数
let headerHeightTrigger = getFirstHeaderSectionHeight();

// 現在のページがトップページかどうかを判定
function isTopPage() {
    return window.location.pathname === '/';
}

// スクロールイベントの処理
function handleScroll() {
    const scrollY = window.scrollY;
    const isTop = isTopPage();

    if (scrollY >= headerHeightTrigger) {
        if (isTop) {
            headerWrapper.classList.remove('is-light');
        } else if (window.innerWidth > 768) {
            const siteHeaderHeight = siteHeader.offsetHeight;
            mainContent.style.paddingTop = siteHeaderHeight + 'px';
        }

        siteHeader.classList.add('site-header--stuck', 'site-header--opening');
    } else {
        if (isTop) {
            headerWrapper.classList.add('is-light');
        } else if (window.innerWidth > 768) {
            mainContent.style.paddingTop = '';
        }

        siteHeader.classList.remove('site-header--stuck', 'site-header--opening');
    }
}

// ウィンドウリサイズ時の処理
function handleResize() {
    headerHeightTrigger = getFirstHeaderSectionHeight();

    handleScroll();
}

// スクロールイベントリスナーの追加
window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', handleResize);

// 初期状態の設定（ページ読み込み時）
handleScroll();
